// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"001ff1b0","453":"07dbad3e","455":"0fb6e0ce","977":"3ed69f1e"}[chunkId] + ".chunk.js";
};